import { useState, useEffect } from 'react';
import { PriceAndQuantity } from './types';
import { CartService } from '../../../../services';

const maxTotalOrderBeforeTax = 3000;

export const useLimit = (products: PriceAndQuantity[]): boolean => {
  const [update, setUpdate] = useState(false);
  const refreshLimit = () => setUpdate(!update);

  useEffect(() => {
    window.addEventListener(CartService.cartUpdateEvent, refreshLimit);
    return () => window.removeEventListener(CartService.cartUpdateEvent, refreshLimit);
  }, [update]);

  try {
    return products
      .map(({ price, quantity }) => parseFloat(price) * quantity)
      .reduce((a, b) => a + b, 0) > maxTotalOrderBeforeTax;
  } catch {
    return true;
  }
};
